
import { Component } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SHARED_COMPONENTS } from '../../../shared/shared-imports';

@Component({
  selector: 'app-venue-bookings',
  imports: [ReactiveFormsModule, TranslateModule, ...SHARED_COMPONENTS],
  templateUrl: './venue-bookings.component.html',
  styleUrl: './venue-bookings.component.scss'
})
export class VenueBookingsComponent {

  filterForm: FormGroup;
  rows = [
    {
      applicationId: '1-20816141245',
      serviceLabel: 'To whom it may concern…',
      membershipLabel: 'Tribal Experience',
      invoice: '39494994',
      date: '03 Nov 2024',
      status: 'Action required',
      jobNumber: '800'
    },
    {
      applicationId: '1-20816141245',
      serviceLabel: 'To whom it may concern…',
      membershipLabel: 'Tribal Experience',
      invoice: '39494994',
      date: '03 Nov 2024',
      status: 'Action required',
      jobNumber: '800'
    },
    {
      applicationId: '1-20816141245',
      serviceLabel: 'To whom it may concern…',
      membershipLabel: 'Tribal Experience',
      invoice: '39494994',
      date: '03 Nov 2024',
      status: 'Action required',
      jobNumber: '800'
    },
    {
      applicationId: '1-20816141245',
      serviceLabel: 'To whom it may concern…',
      membershipLabel: 'Tribal Experience',
      invoice: '39494994',
      date: '03 Nov 2024',
      status: 'Action required',
      jobNumber: '800'
    }
  ];

  /* options for the <app-select> filters */
  services: any = [
    { "label": "All", "value": "All" },
    { "label": "Membership", "value": "Membership" },
    { "label": "Certificate of Origin", "value": "Certificate of Origin" },
    { "label": "Attestation", "value": "Attestation" }
  ]
  memberships: any = [
    { "label": "All", "value": "All" },
    { "label": "Tribal Experience", "value": "Tribal Experience" },
    { "label": "Aramex", "value": "Aramex" }
  ]

  statuses: any = [
    { "label": "All", "value": "All" },
    { "label": "Action required", "value": "Action required" },
    { "label": "Pending", "value": "Pending" },
    { "label": "Completed", "value": "Completed" }
  ]
  users: any = [
    { "label": "All", "value": "All" },
    { "label": "You", "value": "You" },
    { "label": "User A", "value": "User A" },
    { "label": "User B", "value": "User B" }
  ]
  dateRanges: any = [
    { "label": "Today", "value": "Today" },
    { "label": "Last 30 days", "value": "Last 30 days" },
    { "label": "Last year", "value": "Last year" }
  ]

  /* current filter selections */
  filter: any = { service: 'All', membership: 'All', status: 'All', user: 'All', date: null, search: '' };

  /* computed table rows */
  // This method is used to filter ed rows
  get filteredRows() {
    return this.rows.filter(r => this.pass(r));
  }


  // This method is used to initialize the class instance using fb
  constructor(private fb: FormBuilder) {
    this.filterForm = this.fb.group({
      service: [''],
      membership: [''],
      status: [''],
      user: [''],
      date: [''],
      search: ['']
    });
  }

  // This method is used to f
  get f() {
    return this.filterForm.value;
  }

  // This method is used to pass using r
  private pass(r: any): boolean {
    const f = this.filter;
    return (f.service === 'All' || r.serviceLabel.includes(f.service)) &&
      (f.membership === 'All' || r.membershipLabel.includes(f.membership)) &&
      (f.status === 'All' || r.status.includes(f.status)) &&
      (f.user === 'All' || r.membershipLabel.includes(f.user)) &&
      (!f.search || JSON.stringify(r).toLowerCase().includes(f.search.toLowerCase()));
  }

  /* ── actions ─────────────────────────── */
  // This method is used to apply for service
  applyForService() { /* navigate to wizard */ }
  // This method is used to export csv
  exportCSV() { /* export rows to CSV  */ }

  // This method is used to view app using row
  viewApp(row: any) { /* open detail page    */ }
  // This method is used to more actions using row
  moreActions(row: any) { /* show contextual menu */ }
}
